import {
    ICrossPromoAssetData,
    CrossPromoPlacement,
    CrossPromoAssetType,
} from './CrossPromoDriver';
import Game from '../../Game';

export default class CrossPromoCampaign {
    private data: any;

    constructor(data: any) {
        this.data = data;
    }

    public queueAsset(type: CrossPromoAssetType, language?: string): string {
        const key: string = this.getAssetKey(type, language);
        const src: string = this.getAssetSource(type, language);
        Game.resource.add(key, src, undefined, true);

        return key;
    }

    public async loadAsset(
        type: CrossPromoAssetType,
        language?: string
    ): Promise<string> {
        const key: string = this.queueAsset(type, language);
        await Game.resource.load();
        return key;
    }

    public getAssetKey(
        type: CrossPromoAssetType,
        language: string = Game.sdk.getLanguage()
    ): string {
        return `${this.data.name}/${type}_${language}`;
    }

    private getAssetSource(
        type: CrossPromoAssetType,
        language?: string
    ): string {
        if (this.data === undefined) {
            console.warn('No XPromo data found');
            return undefined;
        }

        const allAssets: ICrossPromoAssetData[] = this.data.assets;
        const assetsOfType: ICrossPromoAssetData[] = allAssets.filter(
            (asset: ICrossPromoAssetData) => asset.type === type
        );
        const assetOfLang: ICrossPromoAssetData = assetsOfType.find(
            (asset: ICrossPromoAssetData) => asset.language === language
        );
        const defaultOfType: ICrossPromoAssetData = assetsOfType.find(
            (asset: ICrossPromoAssetData) => asset.language === 'default'
        );
        const asset: ICrossPromoAssetData =
            assetOfLang !== undefined ? assetOfLang : defaultOfType;

        if (asset === undefined) {
            console.warn(
                `No XPromo asset data found. Type: ${type}, Lang: ${language}`
            );
            return undefined;
        }

        return asset.src;
    }

    public get id(): number {
        return this.data ? this.data.id : undefined;
    }

    public get placement(): CrossPromoPlacement {
        return this.data ? this.data.placeholder : undefined;
    }
}
